import _ from 'lodash';

import { LEX_TOKEN_TYPES } from 'constants/parser';

export const getErrorPositionInfo = (start, end) => {
  if (_.isNil(start) || _.isNil(end)) {
    return '';
  }

  return `[${start}, ${end}]`;
};

const getErrorMessage = (type, value, position) => {
  switch (type) {
    case LEX_TOKEN_TYPES.bracket:
    case LEX_TOKEN_TYPES.separator:
    case LEX_TOKEN_TYPES.anySingleCharacter:
      return `Unexpected char: ${value} ${getErrorPositionInfo(position?.start, position?.end)}`;

    default:
      return `Check expression: ${value} ${getErrorPositionInfo(position?.start, position?.end)}`;
  }
};

export const getError = (token, parent) => {
  const { type, position, value } = token || parent;

  return {
    type,
    message: getErrorMessage(type, value, position),
    position,
  };
};
